import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useLocation } from '@app/utils';
import {
  HeaderLogo,
  NavItems,
  TransactionSearch,
  Container,
  NavText,
  NavContainer,
  NavBox,
  ButtonContainer,
  Actions,
  Text,
  ProfileIcon,
  DropDownArrow,
  HeaderDropDown,
  DropDownOption,
  LogoutText,
  NavIcon,
  SearchItem,
  ButtonItem,
  MobileNavItems,
  MobileSideNav,
  SideNavActions,
  SideNavOption,
  NavIcon1,
  UserDropdown,
  UserDropdownValue,
  UserManagement,
} from '@app/components/header-navigations/header-navigations-components';
import { Button, Icon } from '@app/components';
import Search from '@app/components/search';
import { Link } from '@app/components';
import { AuthContext } from '@app/providers';
import { signOut } from '@app/auth/firebase';
import { useGetUserQuery, useAddOrRemoveToken } from '@app/graphql';
import { useHistory } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { whiteColor } from '@app/styles';
import { getDefaultUrl } from '@app/routes/routes-helper';
import {
  createTransaction,
  municipalityPermission,
  showTransactionPage,
} from '@app/utils/permissions';
import SearchTransaction from '@app/modules/transactions/search-transaction';
const MenuIconStyle = {
  height: 50,
  width: 20,
  marginLeft: 10,
};

type props = {
  location?: string;
  image?: '';
};
export default function HeaderNavigations({ location, image }: props) {
  const { userInfo, setUserInfo }: any = useContext(AuthContext);
  const defaultUrl: string = getDefaultUrl(userInfo);
  const { displayName = '', profilePicUrl = '', userUpdated = null } =
    userInfo || {};
  const [removeToken] = useAddOrRemoveToken();
  const [showDropdown, toggleDropdown] = React.useState(false);
  const [showUserDropdown, setShowUserDropdown] = React.useState(false);
  const [showSideNav, toggleSideNav] = React.useState(false);
  const dropdownRef: any = React.useRef(null);
  const sideNavRef: any = React.useRef(null);
  const fileDropdownRef: any = React.useRef(null);
  const userDropdownRef: any = React.useRef(null);
  const [profileImage, updateProfileImage] = React.useState(profilePicUrl);
  const { loading, data } = useGetUserQuery({
    firebaseId: userInfo ? userInfo.id : '',
  });
  const [isUserDataUpdated, setUserDataFlag] = React.useState(false);
  const [showProgress, toggleProgress] = React.useState(false);
  const { searchText: transactionSearchText }: any = useParams();
  const [transactionSearch, setTransactionsearch] = React.useState<string>(
    transactionSearchText || '',
  );
  const [showSearchTransaction, setShowSearchTransaction] = React.useState(
    false,
  );

  let history = useHistory();

  React.useEffect(() => {
    if (!loading && data && data.user && !isUserDataUpdated && !userUpdated) {
      setUserInfo({
        ...data.user,
        displayName: data.user.firstName + ' ' + data.user.lastName,
        id: data.user.firebaseId,
        userUpdated: true,
      });
      updateProfileImage(data.user.profilePicUrl);
      setUserDataFlag(true);
    }
  }, [
    isUserDataUpdated,
    loading,
    data,
    userUpdated,
    setUserInfo,
    history.location.pathname,
  ]);

  const pathName =
    history.location.pathname !== '/municipalities' &&
    history.location.pathname !== '/transactions'
      ? history.location.pathname.split('/', 3)
      : [];

  const getMainPage = () => {
    const {
      location: { pathname },
    } = history;
    let mainPage = '';
    if (pathname.includes('/municipalities')) {
      mainPage = 'municipalities';
    } else if (pathname.includes('/transactions')) {
      mainPage = 'transactions';
    } else if (pathname.includes('/users')) {
      mainPage = 'users';
    } else if (pathname.includes('/user-roles')) {
      mainPage = 'user-roles';
    }
    return mainPage;
  };
  const checkTransactionButton = () => {
    if (
      createTransaction(userInfo) &&
      history.location.pathname !== '/transactions' &&
      history.location.pathname !== '/transactions/approved' &&
      history.location.pathname !== '/transactions/create'
    ) {
      return true;
    }
    return false;
  };
  const mainPage = getMainPage();

  function handleClickOutside(e: any) {
    if (
      showDropdown &&
      dropdownRef.current &&
      !dropdownRef.current.contains(e.target)
    ) {
      toggleDropdown(false);
    }
    if (
      showProgress &&
      fileDropdownRef.current &&
      !fileDropdownRef.current.contains(e.target)
    ) {
      toggleProgress(false);
    }
    if (
      showUserDropdown &&
      userDropdownRef.current &&
      !userDropdownRef.current.contains(e.target)
    ) {
      setShowUserDropdown(false);
    }
    if (
      showSideNav &&
      sideNavRef.current &&
      !sideNavRef.current.contains(e.target)
    ) {
      toggleSideNav(false);
    }
  }
  document.addEventListener('click', handleClickOutside);

  const { navigate } = useLocation();
  const Logout = async () => {
    const token: string = localStorage.getItem('token') || '';
    const params = {
      token: token,
      firebaseId: userInfo ? userInfo.id : '',
      expiryDateTime: Date(),
      action: 'REMOVE',
    };
    await removeToken({ variables: params })
      .then((res: any) => {})
      .catch((error: any) => {
        console.log(error);
      });
    signOut();
    setUserInfo(null);
    toggleDropdown(false);
    setTimeout(() => {
      navigate('/sign-in');
    }, 500);
  };

  function navigateTo(page: string) {
    toggleDropdown(false);
    navigate(page);
  }

  const handleTransactionSearch = React.useCallback((value: string) => {
    setTransactionsearch(value);
  }, []);

  const getPagePrefix = () => {
    const {
      location: { pathname },
    } = history;
    const pagePrefix = pathname.includes('/transactions/approved')
      ? '/transactions/approved'
      : '/transactions';

    return pagePrefix;
  };

  const handleTransactionSearchClear = () => {
    const pagePrefix = getPagePrefix();
    setTransactionsearch('');
    navigate(pagePrefix);
  };

  const onEnterTransactionSearch = React.useCallback(
    (event: any) => {
      setTransactionsearch(event.target.value);
      const pagePrefix = getPagePrefix();
      if (transactionSearch) {
        setShowSearchTransaction(true);
      } else {
        navigate(pagePrefix);
      }
    },
    // eslint-disable-next-line
    [navigate, transactionSearch],
  );
  const closeSearch = () => {
    setTransactionsearch('');
    setShowSearchTransaction(false);
  };
  const onSubmitTransactionSearch = React.useCallback(
    () => {
      const pagePrefix = getPagePrefix();
      if (transactionSearch) {
        navigate(pagePrefix + '/search/' + transactionSearch);
      } else {
        navigate(pagePrefix);
      }
    },
    // eslint-disable-next-line
    [navigate, transactionSearch],
  );
  type SideNavProps = {
    iconName: string;
    title: string;
    route: string;
    page: string;
    show: boolean;
  };
  const sideNavOptoins: SideNavProps[] = [
    {
      iconName: 'municipality',
      title: 'Municipalities',
      route: '/municipalities',
      page: 'municipalities',
      show: municipalityPermission(userInfo) || false,
    },
    {
      iconName: 'transaction',
      title: 'Transactions',
      route: '/transactions',
      page: 'transactions',
      show: showTransactionPage(userInfo) || false,
    },
    {
      iconName: 'user',
      title: 'User Management',
      route: '/users',
      page: 'users',
      show: userInfo && userInfo.userType === 'super_admin' ? true : false,
    },
    {
      iconName: 'user',
      title: 'User Roles',
      route: '/user-roles',
      page: 'user-roles',
      show: userInfo && userInfo.userType === 'super_admin' ? true : false,
    },
  ];
  return (
    <>
      <Container>
        <NavBox>
          <SideNavActions>
            <div ref={sideNavRef}>
              <FontAwesomeIcon
                color={whiteColor}
                icon={faBars}
                style={MenuIconStyle}
                onClick={() => {
                  toggleSideNav(!showSideNav);
                }}
              />

              {showSideNav && (
                <MobileSideNav>
                  {sideNavOptoins.map((sideNav: SideNavProps) => {
                    return (
                      <>
                        {sideNav.show ? (
                          <SideNavOption
                            onClick={() => {
                              navigate(sideNav.route);
                              toggleSideNav(!showSideNav);
                            }}>
                            <NavContainer>
                              <NavIcon active={mainPage === sideNav.page}>
                                <Icon
                                  name={
                                    sideNav.iconName === 'user'
                                      ? 'user'
                                      : sideNav.iconName === 'transaction'
                                      ? 'transaction'
                                      : sideNav.iconName === 'municipality'
                                      ? 'municipality'
                                      : 'user'
                                  }
                                />
                              </NavIcon>
                              <NavText active={mainPage === sideNav.page}>
                                {sideNav.title}
                              </NavText>
                            </NavContainer>
                          </SideNavOption>
                        ) : null}
                      </>
                    );
                  })}
                </MobileSideNav>
              )}
            </div>
          </SideNavActions>
          <NavItems>
            <Link variant="white" href={defaultUrl}>
              <HeaderLogo />
            </Link>
          </NavItems>
          {sideNavOptoins.map((sideNavOption: SideNavProps) => {
            return (
              <>
                {sideNavOption.show ? (
                  <>
                    {sideNavOption.page === 'users' ? (
                      <NavItems
                        ref={userDropdownRef}
                        active={
                          mainPage === 'users' || mainPage === 'user-roles'
                        }>
                        <NavContainer>
                          <UserManagement
                            onClick={() => setShowUserDropdown(true)}>
                            <NavIcon1
                              active={
                                mainPage === 'users' ||
                                mainPage === 'user-roles'
                              }>
                              <Icon name="user" />
                            </NavIcon1>
                            <NavText
                              active={
                                mainPage === 'users' ||
                                mainPage === 'user-roles'
                              }>
                              {mainPage === 'users'
                                ? 'User Management'
                                : mainPage === 'user-roles'
                                ? 'User Roles'
                                : 'Users'}
                            </NavText>
                            <Icon name="arrowDown" />
                          </UserManagement>
                          {showUserDropdown ? (
                            <UserDropdown>
                              <UserDropdownValue
                                onClick={() => {
                                  setShowUserDropdown(false);
                                  navigate('/users');
                                }}>
                                User Management
                              </UserDropdownValue>
                              <UserDropdownValue
                                onClick={() => {
                                  setShowUserDropdown(false);
                                  navigate('/user-roles');
                                }}>
                                User Roles
                              </UserDropdownValue>
                            </UserDropdown>
                          ) : null}
                        </NavContainer>
                      </NavItems>
                    ) : sideNavOption.page === 'user-roles' ? null : (
                      <NavItems
                        active={mainPage === sideNavOption.page}
                        onClick={() => navigate(sideNavOption.route)}>
                        <NavContainer>
                          <NavIcon active={mainPage === sideNavOption.page}>
                            <Icon
                              name={
                                sideNavOption.iconName === 'municipality'
                                  ? 'municipality'
                                  : 'transaction'
                              }
                            />
                          </NavIcon>
                          <NavText active={mainPage === sideNavOption.page}>
                            {sideNavOption.title}
                          </NavText>
                        </NavContainer>
                      </NavItems>
                    )}
                  </>
                ) : null}
              </>
            );
          })}
        </NavBox>
        <MobileNavItems>
          <Link variant="white" href="/municipalities">
            <HeaderLogo />
          </Link>
        </MobileNavItems>
        <ButtonContainer>
          {history.location.pathname === '/transactions' ||
          history.location.pathname === '/transactions/approved' ||
          pathName[2] === 'search' ||
          pathName[2] === 'approved' ? (
            <TransactionSearch>
              <SearchItem>
                <Search
                  isHeaderSearch={true}
                  placeholder="Search"
                  value={transactionSearch}
                  disabled={false}
                  onValueChange={handleTransactionSearch}
                  onClear={handleTransactionSearchClear}
                  variant="header"
                  onKeyUp={onEnterTransactionSearch}
                  submitSearch={onSubmitTransactionSearch}
                />
              </SearchItem>
              {showSearchTransaction ? (
                <SearchTransaction
                  showSearchTransaction={showSearchTransaction}
                  closeSearch={closeSearch}
                  transactionSearchText={transactionSearch}
                />
              ) : null}
            </TransactionSearch>
          ) : (
            ''
          )}
          {checkTransactionButton() ? (
            <ButtonItem>
              <Button
                variant="warning"
                size="medium"
                width="100%"
                type="submit"
                onClick={() => navigate('/transactions/create')}>
                New Transaction
              </Button>
            </ButtonItem>
          ) : null}
          <Actions>
            <div ref={dropdownRef} className="profile">
              <Text onClick={() => toggleDropdown(!showDropdown)}>
                {displayName}
              </Text>
              <ProfileIcon
                image={profileImage || profilePicUrl || image}
                onClick={() => toggleDropdown(!showDropdown)}
              />
              <DropDownArrow onClick={() => toggleDropdown(!showDropdown)} />
              {showDropdown ? (
                <HeaderDropDown>
                  <DropDownOption onClick={() => navigateTo('/profile')}>
                    My Profile
                  </DropDownOption>
                  <DropDownOption
                    onClick={() => navigateTo('/change-password')}>
                    Change Password
                  </DropDownOption>
                  <DropDownOption onClick={() => Logout()}>
                    <LogoutText>Sign out</LogoutText>
                  </DropDownOption>
                </HeaderDropDown>
              ) : null}
            </div>
          </Actions>
        </ButtonContainer>
      </Container>
    </>
  );
}
